export type DirectoryMailboxStatus = "none" | "pending" | "active" | "disabled";

export type DirectoryMailboxInfo = {
  status: DirectoryMailboxStatus;
  email: string | null;
};

export function mailboxStatusLabel(status: DirectoryMailboxStatus): string {
  switch (status) {
    case "active":
      return "Mailbox ready";
    case "pending":
      return "Mailbox pending";
    case "disabled":
      return "Mailbox disabled";
    default:
      return "No mailbox";
  }
}
